import { render } from "./BrokerClient.vue?vue&type=template&id=5388ab82"
import script from "./BrokerClient.vue?vue&type=script&lang=js"
export * from "./BrokerClient.vue?vue&type=script&lang=js"

import "./BrokerClient.vue?vue&type=style&index=0&id=5388ab82&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__